<template>
    <div
        class="rounded overflow-hidden border-1 border-gray-200 hover:shadow-2xl shadow hover:-translate-y-5 transition-all">
        <router-link :style="{ backgroundImage: `url(${getMapUrl(cafe)})` }"
                     :to="cafe.url"
                     class="block min-h-[150px] flex items-center justify-center bg-cover bg-indigo-400">
        </router-link>

        <div class="p-15">
            <router-link :to="cafe.url">
                <h3 class="font-bold text-2xl mb-5">
                    {{ cafe.name }}
                </h3>
            </router-link>

            <h4 v-if="cafe.recently_verified" class="font-bold text-indigo-400 mb-10">
                ✅ Recently verified
            </h4>

            <h4 v-else-if="cafe.recently_added" class="font-bold mb-10">
                ✅ Recently added
            </h4>

            <h4 v-else class="font-bold mb-10">
                Added {{ cafe.added_relative_ago }}
            </h4>

            <div v-for="verification in cafe.user_verifications" class="py-10">
                <router-link :to="cafe.url">
                    <p class="italic verification__remarks line-clamp-3">{{ verification.remarks }}</p>
                </router-link>

                <p class="text-gray-600 mt-10">Verified by
                    <a
                        :href="`https://twitter.com/${verification.user.twitter_username}`"
                        class="text-indigo-400 hover:text-pink-500 focus:text-pink-500"
                        rel="nofollow noopener"
                        target="_blank"
                    >
                        <img
                            :src="`${verification.user.public_avatar_url}&s=30`"
                            alt=""
                            class="inline-block rounded-full border-1 border-indigo-400"
                            height="30"
                            width="30">
                        {{ verification.user.public_name }}
                    </a>,
                    {{ verification.verified_relative_ago }}</p>
            </div>

            <div class="flex gap-5 mt-5 flex-wrap">
                <Tag v-for="tag in cafe.tags" :key="tag.slug">
                    <span class="emoji">{{ tag.emoji }}</span> {{ tag.name }}
                </Tag>
            </div>
        </div>
    </div>
</template>

<script>
import Tag from "./Tag";

export default {
    name: "WorkplaceGridItem",
    components: {Tag},
    props: {
        cafe: Object
    },
    methods: {
        getMapUrl(cafe) {
            return `https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/${cafe.longitude},${cafe.latitude},13.1,0/330x150?access_token=pk.eyJ1IjoibWF4a29ybGFhciIsImEiOiJja3lwdjRnYXkwZG9mMnBvNTRmenc5bXIwIn0.v0fnsuk-QnMj86agJ5ITzA`;
        }
    }
}
</script>
<style lang="scss" scoped>
.verification {
    &__remarks {
        &::before, &::after {
            content: '"';
        }
    }
}
</style>
